import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=097ffd24&scoped=true&"
import script from "./userinfo.vue?vue&type=script&lang=js&"
export * from "./userinfo.vue?vue&type=script&lang=js&"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=097ffd24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ffd24",
  null
  
)

export default component.exports